import {
  APP_CLIENT_STORAGE_KEY,
  APP_UID_STORAGE_KEY,
  AUTH_TOKEN_COOKIE_KEY,
  LOGIN_STORAGE_KEY,
  USER_PRIVILEGES_STORAGE_KEY,
  USER_STORAGE_KEY,
} from "constants";
import CryptoJS from "crypto-js";
import dayjs from "dayjs";
import { getAppLanguage } from "helpers/getAppLanguage";
import { getCookie, removeCookie } from "utils/cookie";
import { getStorageItem, removeStorageItem } from "utils/localStorage";
import { createPrivilegeObject } from "utils/privileges/privilegesMapper";

export const getAppCredentials = () => {
  const token = getCookie(AUTH_TOKEN_COOKIE_KEY); // HTTP Only
  const privileges = getStorageItem(USER_PRIVILEGES_STORAGE_KEY);
  const isLoggedIn = getStorageItem(LOGIN_STORAGE_KEY);
  const info = getStorageItem(USER_STORAGE_KEY);
  const language = getAppLanguage();

  return {
    auth: { token, isLoggedIn: isLoggedIn === "no" ? false : !!isLoggedIn },
    configs: {
      ...language,
      direction: language?.rtl ? "rtl" : "ltr",
      locale: language.locale,
      screenSize: { width: window?.innerWidth, height: window?.innerHeight },
    },
    user: { info },
    privileges: privileges ? createPrivilegeObject(privileges) : null,
  };
};

export const removeAppCredentials = (saveUrl, reload) => {
  // Remove all authentication cookies
  removeCookie(AUTH_TOKEN_COOKIE_KEY);
  removeCookie(APP_CLIENT_STORAGE_KEY);
  removeCookie(APP_UID_STORAGE_KEY);
  // Remove all user-related storage items
  removeStorageItem(USER_STORAGE_KEY);
  removeStorageItem(USER_PRIVILEGES_STORAGE_KEY);
  removeStorageItem(LOGIN_STORAGE_KEY);
  // reload && window.location.reload();
};

export const performEncryption = (value) => {
  const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_ENCRYPTION_KEY);
  const iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_ENCRYPTION_HEX_KEY);
  return CryptoJS.AES.encrypt(value, key, { iv: iv }).toString();
};
export const performDecryption = (value) => {
  const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_ENCRYPTION_KEY);
  return CryptoJS.AES.decrypt(value, key, {
    iv: CryptoJS.enc.Hex.parse(process.env.REACT_APP_ENCRYPTION_HEX_KEY),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
};

export const redirectExternal = (redirectUrl) => {
  const baseUrl = window?.location?.origin;
  const targetUrl = baseUrl + redirectUrl;
  if (baseUrl && window.location.href !== targetUrl) {
    window.location.replace(targetUrl);
  }
}

export const uploadAttachment = (e) => {
  return [
    {
      url: e?.url,
      thumbUrl: e?.url,
      name: e?.file_name,
      status: "done",
      uid: e?.id,
      type: e?.attachment_type || e?.key,
      documentId: e?.id,
      id: e?.attachment_id || e?.id,
      response: {id : e?.attachment_id || e?.id}
    },
  ]
}